import React from "react";
import banner from "../../images/banner.png";
import "./home.css";

function Banner() {
  return (
    <div>
      <img id="banner-image" class="img-fluid" src={banner} loading="lazy" />
      <div className="banner-text">
          <p>Ganj Mesopotamia General Trading Ltd.</p>
          <h4>Connect Global Market with Quality Products</h4>
          <a href="/products" className="btn btn-primary banner-btn py-1" style={{fontSize: '16px'}}>View Products</a> 
      </div>
    </div>
  );
}

export default Banner;
